import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { UserContext } from '../contexts/UserContext';
import Cookies from 'js-cookie';

const ProtectedRoute = ({ children }) => {
    const { user, isLoading } = useContext(UserContext);
    const hasAuthToken = Cookies.get('authToken');

    // If still loading but user has a token, show the children immediately
    // This prevents the fullscreen loading overlay from blocking interaction
    if (isLoading) {
        // If there's a token, assume user is authenticated and show children
        // The actual auth check will happen when loading completes
        if (hasAuthToken) {
            return children;
        }
        // If no token and still loading, redirect to login
        return <Navigate to="/login" replace />;
    }

    // After loading, if no user, redirect to login
    if (!user) {
        return <Navigate to="/login" replace />;
    }

    return children;
};

export default ProtectedRoute;